import React from 'react';
import { DateRange } from 'react-date-range';
import { addMonths, subMonths, format } from 'date-fns';
import { useClassName } from 'common/hooks';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './styles/date-range-picker.less';

const DateRangePicker = ({ filters, onDateChange }) => {
  const classNames = useClassName('DateRangePicker');

  const selectionRange = {
    startDate: filters.customDate?.startDate || new Date(),
    endDate: filters.customDate?.endDate || new Date(),
    key: 'selection',
    color: '#2348f2',
  };

  const navigatorRenderer = (focusedDate, changeShownDate) => {
    const handlePrevClick = () => {
      changeShownDate(subMonths(focusedDate, 1));
    };

    const handleNextClick = () => {
      changeShownDate(addMonths(focusedDate, 1));
    };

    return (
      <div className="rdrMonthAndYearWrapper custom-navigator">
        <button
          type="button"
          className="rdrNextPrevButton rdrPprevButton"
          onClick={handlePrevClick}
          aria-label="Previous Month">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            fill="none">
            <path
              d="M15.4167 10.5H5M5 10.5L10 15.5M5 10.5L10 5.5"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <span className="combinedMonthYear">
          {format(focusedDate, 'MMMM yyyy')}
        </span>
        <button
          type="button"
          className="rdrNextPrevButton rdrNextButton"
          onClick={handleNextClick}
          aria-label="Next Month">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            fill="none">
            <path
              d="M5.00033 10.5H15.417M15.417 10.5L10.417 5.5M15.417 10.5L10.417 15.5"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    );
  };

  return (
    <div className={classNames('container')}>
      <div className={classNames('picker-and-reset')}>
        <DateRange
          ranges={[selectionRange]}
          onChange={onDateChange}
          showDateDisplay={false}
          navigatorRenderer={navigatorRenderer}
          showPreview
          weekdayDisplayFormat="EEEEE"
          minDate={new Date()}
          rangeColors={['#2348f2']}
          moveRangeOnFirstSelection={false}
          // showMonthAndYearPickers={false}
          // className="date-picker"
        />
        <button
          onClick={() =>
            onDateChange({ selection: { startDate: null, endDate: null } })
          }
          className={classNames('reset-date')}>
          Reset Date
        </button>
      </div>
    </div>
  );
};

export default DateRangePicker;
